export class OSP {
  recordId?: number;
  clientName?: string;
  obu?: string;
  constructionType?: string;
  estCompletion?: string;
  jobLocation?: string;
  enabled?: boolean;
  state?: string;
  materialType?: string;
  _jobName?: string;
  currentJobStatus?: string;
  relatedProject?: string;
  clientNameAndProject?: string;
  clientAndProject?: string;
  constType?: string;
  prismId?: string;
  workOrder?: string;
  ospStatus?: string;
  contractPartners?: string[];
  assignmentCPName?: string;
  taskRecords?: string;
  jobType?: string;
  clientJobId?: string;
  projectName?: string;
  dueDate?: string;
  withAttachments?: boolean;
  relatedClient?: string;
  limitWorkDate?: boolean;
  dailyImporterJobName?: string;
  backdateLimitDays?: number;
  enforceOverageLimit?: boolean;
  get wfNumber(): string {
    if (!this.prismId) {
      return this.clientJobId;
    }

    return this.prismId;
  }

  get wfOrPrism(): string {
    if (!this.prismId) {
      return 'WF Number:';
    }

    return 'Prism ID:';
  }

  get jobName(): string {
    // Use a new calculated field from QuickBase if available
    if (this.dailyImporterJobName) {
      return this.dailyImporterJobName;
    }

    // Fallback (old logic)
    let name = this.obu.substring(0, 6);
    if (!this.jobLocation) {
      return name + ': ' + this._jobName;
    }

    return name + ': ' + this.jobLocation;
  }

  get displayName(): string {
    const baseName = this.jobName;
    if (this.currentJobStatus === 'Completed PR') {
      return `${baseName} (Completed PR)`;
    }
    return baseName;
  }

  constructor(data: any) {
    this.recordId = data[3]?.value;
    this.clientJobId = data[8]?.value;
    this._jobName = data[9]?.value;
    this.materialType = data[14]?.value;
    this.currentJobStatus = data[15]?.value;
    this.relatedProject = data[23]?.value;
    this.obu = data[24]?.value;
    this.clientName = data[25]?.value;
    this.clientNameAndProject = data[46]?.value;
    this.clientAndProject = data[72]?.value;
    this.constType = data[85]?.value;
    this.estCompletion = data[86]?.value;
    this.jobLocation = data[88]?.value;
    this.prismId = data[91]?.value;
    this.workOrder = data[95]?.value;
    this.ospStatus = data[100]?.value;
    this.jobType = data[103]?.value;
    this.contractPartners = data[108]?.value;
    this.assignmentCPName = data[116]?.value;
    this.dueDate = data[137]?.value;
    this.taskRecords = data[148]?.value;
    this.projectName = data[189]?.value;
    this.withAttachments = data[196]?.value;
    this.relatedClient = data[206]?.value;
    // LH-45 (2026-05-15): fid 218 = "Project - Limit Work Date to Today only" (lookup via
    // Jobs.Related Project rel). Previously this read fid 209 which is unrelated
    // ("File Attachment without Uploaded From Where exists") — limitWorkDate was always
    // undefined, so the date-picker disable never triggered. Backend already queries 218.
    this.limitWorkDate = data[218]?.value;
    this.dailyImporterJobName = data[260]?.value;
    // LH-45 (2026-05-15): fid 261 = "Project - Work Date Backdate Limit (Days)" lookup.
    // Project field 164 (default 7) cascades here. Used by daily-importer-v3 minDate getter.
    this.backdateLimitDays = data[261]?.value;
    // LH-52 (2026-09-05): "Project - Enforce Daily Report Overage Limit".
    // Read by NAME, not by fid, on purpose. The backend resolves the env-specific
    // field id (DEV Jobs 263) and emits this stable key, because PROD Jobs 263 is
    // already "UG CPs from Dailies" — a hardcoded literal here would diverge the
    // dev and prod branches again, exactly as the LH-45 fids did.
    this.enforceOverageLimit = data['enforceOverageLimit']?.value;
  }
}
